/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileTable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M16 19H8v-8h8zm-6-2h1v-1h-1zm3 0h1v-1h-1zm-3-3h1v-1h-1zm3 0h1v-1h-1z" />
        <path d="M20 7.586V22H4V2h10.414zM6 20h12V9h-5V4H6zm9-13h1.586L15 5.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileTable as FileTable };
